// Native bridge helpers — gracefully degrade when running in a regular browser.
// The Capacitor `Capacitor.isNativePlatform()` flag tells us we're inside the
// Android/iOS shell.
import { Capacitor } from "@capacitor/core";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'web' | 'android' | 'ios'

/**
 * Take a photo using the device camera (native) or fall back to a plain file
 * input (web). Returns a `data:image/...;base64,xxxx` URL ready to feed to
 * <img> or to send to /api/diagnose.
 */
export async function pickPhoto({ source = "prompt" } = {}) {
  if (!isNative()) return null; // caller falls back to <input type=file>
  const src =
    source === "camera"
      ? CameraSource.Camera
      : source === "library"
        ? CameraSource.Photos
        : CameraSource.Prompt;
  const photo = await Camera.getPhoto({
    quality: 80,
    allowEditing: false,
    resultType: CameraResultType.DataUrl,
    source: src,
    width: 1600,
  });
  return photo.dataUrl || null;
}
